export default __webpack_public_path__ + "static/media/onboarding.d72baab8.svg";